import { fetchEmployees } from '@/lib/request/fetchEmployees';
import type { Employees, Employee } from '@/lib/request/types/employee';
import type { Timesheets } from '@/lib/request/types/timesheet';
import type { Rosters } from '@/lib/request/types/roster';
import { defineStore } from 'pinia';

export interface EmployeeStoreStatus {
  isLoading: boolean;
}

export interface EmployeeStoreErrors {
  loadingError: Error | null;
}

export interface EmployeeStore {
  data: Employees;
  status: EmployeeStoreStatus;
  errors: EmployeeStoreErrors;
}

export interface EmployeeWithTimesheet {
  employee: Employee;
  rosters: Rosters;
  timesheets: Timesheets;
}

export const useEmployeeStore = defineStore({
  id: 'employee',
  state: (): EmployeeStore => ({
    data: [],
    status: {
      isLoading: false,
    },
    errors: {
      loadingError: null,
    },
  }),
  getters: {
    getByEmployeeId(state) {
      return (Id: number) => state.data.find((employee) => employee.Id === Id);
    },
  },
  actions: {
    async load() {
      this.errors.loadingError = null;
      this.status.isLoading = true;
      try {
        this.data = await fetchEmployees();
      } catch (e) {
        if (e instanceof Error) {
          this.errors.loadingError = e;
          throw e;
        }
      } finally {
        this.status.isLoading = false;
      }
    },
  },
});
